import { engineRequest } from './http';

// Paged. Query: `role` (role key), `status` (`active` | `inactive` | `all`),
// `search` (name, phone, email), `site_id`, `page`, `page_size`.
export const listMembers = params =>
  engineRequest({ path: '/service-team', params });

export const getMember = id => engineRequest({ path: `/service-team/${id}` });

export const createMember = fields =>
  engineRequest({ method: 'post', path: '/service-team', data: fields });

// `coverage` and `leave` replace the whole list when sent. The response adds
// `visits_flagged` (new leave hit booked visits) and `reroute` (the member was
// deactivated).
export const updateMember = (id, fields) =>
  engineRequest({ method: 'put', path: `/service-team/${id}`, data: fields });

// 409 `in_use` when tickets or visits reference the member: deactivate instead.
export const deleteMember = id =>
  engineRequest({ method: 'delete', path: `/service-team/${id}` });

// What deactivating would do to the member's open tickets. Writes nothing.
export const getReroutePreview = id =>
  engineRequest({ path: `/service-team/${id}/reroute-preview` });
